import { render } from "./tradeResult_cf.vue?vue&type=template&id=46b7e20f"
import script from "./tradeResult_cf.vue?vue&type=script&lang=js"
export * from "./tradeResult_cf.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__